import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles({
  input: {
    height: 30,
    padding: "4px 42px 4px 18px",
  },
});

export default useStyles;
